export default "__VITE_ASSET__B17a3v8O__"